import { getModel } from '../../model/registry'
import { useEffect, memo, useState } from 'react'
import useToast from '../../hooks/useToast'
import styled from 'styled-components'

//State Logic
import useFormValidation from './useFormValidation'
import useFormModal from '../modal/useModalDialog'

//Importing Form Logic
import useFormActions from './useFormActions'

//Importing the Subcomponents
import CardViewTitle from './CardViewTitle'
import CardViewForm from './CardViewForm'
import MessageBar from '../toast/MessageBar'
import { CardBusyContext } from './cardBusy'
import { PopUp } from '../modal/PopUp'

import { useMessage } from '../pageView/Page'
import { useModalStack } from "../../context/modalStackContext"
import MoveFolderModal from '../documents/MoveFolderModal/MoveFolderModal'
import WorkQueueProgress from './WorkQueueProgress'

const CardViewWrapper = styled.div`
  display: flex;
  gap: 1rem;
  max-width: ${({ width }) => width ? width : ''}  
`
//Importing Local State

const MainForm = styled.div`
  display: block;
  //This ensures the DIV fills all the available space
  flex-grow: 1;
  width: 100%;
`

const CardView = memo(({ type, options, dispatch }) => {

  //State used to manage the MessageBar at the Top of the Form
  const [message, setMessage] = useMessage((s) => s)

  //Managing the Confirmation Dialog
  const { showModal, setShowModal, modalConfig } = useFormModal()
  const { pushModal } = useModalStack()

  //Config to read the data from the Model
  let config = getModel('cardViewData')[type]
  if (options?.backOverride) config = { ...config, backOverride: options.backOverride }
  if (options?.backAction) config = { ...config, backAction: options.backAction }
  if (options?.queue) config = { ...config, queue: options.queue }

  //State to manage the validation state
  const { validated, setValidated } = useFormValidation(config.entity)

  useEffect(() => {
    // Function to run when component unmounts
    return () => {
      //Ensure Validation is turned off & Message is off
      setValidated(false);
      setMessage(false);
      setShowModal(false);
    };
  }, []
  )

  //Getting the State
  const mode = options.mode

  //Hook to show the Toast Message
  const { ToastComponent } = useToast();

  //Pushes the PopUp Modal
  useEffect(() => {
    if (showModal === true ) {
      pushModal(PopUp, { config: modalConfig, setShow: setShowModal, setAction: handleActions })
      setShowModal(false)
    }
  }, [showModal])


  const { handleFormChange, handleActions, showMoveModal, setShowMoveModal, confirmMove, queueStep, busy } = useFormActions(mode, config)

  return (
    <CardBusyContext.Provider value={busy}>
    <CardViewWrapper width={config.width}>
      <MainForm>
        {config.queue && <WorkQueueProgress queue={config.queue} step={queueStep} />}
        {/* Keyed by the message, so "Saving…" then "Saved" is a fresh bar that fades out */}
        {message.show && <MessageBar key={`${message.type}-${message.title}`} title={message.title} message={message.message} type={message.type} setMessage={setMessage} action={message.action || undefined} handleAction={handleFormChange} />}
        {config?.showCardTitle !== false && <CardViewTitle config={config} options={options} handleActions={handleActions} busy={busy} />}
        <CardViewForm config={config} options={options} dispatch={dispatch}
          handleActions={handleActions}
          validated={validated}
        />
        {ToastComponent}
      </MainForm>
      {showMoveModal && (
        <MoveFolderModal
          onClose={() => setShowMoveModal(false)}
          onConfirm={confirmMove}
        />
      )}
    </CardViewWrapper>
    </CardBusyContext.Provider>
  );
})

export default CardView